import React from 'react';
import Router from './components/router';
import ReactGA from 'react-ga4';
// Suppress TS error for side-effect CSS import when no type declarations are present
// @ts-ignore: Cannot find module or type declarations for side-effect import of './App.css'
import './App.css';

const TRACKING_ID = "G-ZBDG6JK7J4";
ReactGA.initialize(TRACKING_ID);

function App() {
  return (
    <div>
      <Router/>
    </div>
  );
}

export default App;
